import { toTypeScript } from '@angular/compiler';
import { Route } from '@angular/compiler/src/core';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../home.service';
import { StreamService } from '../../shared/stream.service';

@Component({
  selector: 'app-notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
})
export class NotificationPanelComponent implements OnInit {
  isLoading:boolean = false;
  notifyList:any
  selected = -1;

  customInput :string;
  constructor(
    private _snackBar:MatSnackBar,
    private router:Router,
    private route:ActivatedRoute,
    private homeService: HomeService,
    private streamService: StreamService,
    ) { }
  from:any;
  circleId:any;
  ownerId:any
  ngOnInit() {
    this.route.queryParams.subscribe(param => {
      this.from = param['from'];
      this.circleId = param['id'];
      this.ownerId = param['ownerId'];

    });
    // this.getNotifyList();
    this.getMentionss();
  }
  pollId:any
  getNotifyList() {
    
      this.isLoading = true;
      let query = "limit=20&offset=0"
      
      this.homeService.getNotifications(query).subscribe((res) => {
        this.isLoading = false;
        if (res['message'] == 'Success') {        
          this.notifyList = res.data.bellNotifications
        } else {
          this.notifyList = [];
        }
      }, err => {
        this.isLoading = false;
      });
    }

memberTypeChange(data){
let IDs = data._id
let ownerIDs = ""
let circleIDs = ""
if(data.circleOwnerId){
  ownerIDs = data.circleOwnerId
}
if(data.circleId){
  circleIDs = data.circleId
}
if(data.type === "RECEIVED_CONNECTION_REQUEST"){
  this.router.navigate(['main/connection/received-req'])
}
if(data.type === "ACCEPTED_CONNECTION_REQUEST"){
  this.router.navigate(['main/connection/your'])
}
if(data.type === "CIRCLE_MENTION"){
  this.router.navigate(['main/circles/circle-profile'],
  { queryParams: { ownerId: ownerIDs, id: circleIDs } })
}
if(data.type === "CIRCLE_REPLY_MENTION"){
  this.router.navigate(['main/circles/circle-profile'],
  {queryParams: { id: circleIDs, ownerId: ownerIDs } })
}
if(data.type === "DISCUSSION_MENTION"){
  this.router.navigate(['main/dashboard/discussion', data.discussionId])
}
if(data.type === "DISCUSSION_REPLY_MENTION"){
  this.router.navigate(['main/dashboard/discussion', data.discussionId])
}
if(data.type === "DIRECT_MESSAGE"){
  this.router.navigate(['main/circles/message/messages-list'],
  {queryParams: { lastId: data.actorId}} )
}
this.streamService.setChatConfigObs({
  chatType: "circle",
  circleData: { circleId: data.circleId, ownerId:data.circleData.ownerId, circleName:data.circleData.name },
  circleGroupData: { circleGroupId: data.circleGroupData.circleGroupId, circleGroupName: data.circleGroupData.title},
  studyData: { studyId: data.chatId, studyNumber: data.studyNumber },
  redirectionData: { isRedirected: true, isReply: data.isReply, chatId: data.isReply ? data.originalChatId : data.chatId, replyId: data.isReply ? data.chatId : "" }
});

this.router.navigate(['/main/circles/circle-profile/circle-members'],{ queryParams: { id: data.circleId, ownerId:data.circleData.ownerId, studyId:data.chatId}})
    }


    mentionsNot:any
totalmentions = 0
mentionMessages:any
newMesg = []
totalnotifications:any
getMentionss() {
  let query = "limit=300&offset=0"
  this.homeService.getMentionNotify(query).subscribe(
    (res) => {
      if (res["message"] == "Success") {
        this.mentionsNot = res.data.chatList;
        this.totalmentions = res.data.totalCount;
        
      this.mentionsNot.forEach(element => {
        // if(element['taggedUsers']){
        //   element['message'] = this.checkTaggedMessages(element);
        // }
        element['shortMessage'] = element['message'].slice(0,80)
        if(element['message'].length > 80){
          element['shortMessage'] = element['shortMessage'] + '...'
        }
        
      });
      this.mentionsNot = this.changeMessageForTags(this.mentionsNot);
      this.ShowHideRead()
      }
    },
    (err) => {}
  );
}
checkTaggedMessages(response) {
  
  let message = response.message;
  let list1 = response.taggedUsers;
  let list2 = response.taggedStudies;
  let list3 = response.taggedPatients;
  for (let i = 0; i < message.length; i++) {
    for (let j = 0; j < list1.length; j++) {
      const regex = "[[" + list1[j]["userId"] + "]]";
      message = message.replaceAll(
        regex,
        `<span class='_label' style='pointer-events: none;'>@${list1[j]["fullName"]} </span>`
      );
    }
    for (let k = 0; k < list2.length; k++) {
      const regex = "[[" + list2[k]["studyId"] + "]]";
      message = message.replaceAll(
        regex,
          "#StudyID: " +
          list2[k]["studyNumber"]
      );
    }
    for (let l = 0; l < list3.length; l++) {
      const regex = "[[" + list3[l]["patientId"] + "]]";
      message = message.replaceAll(
        regex,
          "#patient: " +
          list3[l]["patientIdentifier"]
      );
    }
  }
  return message;
}
changeMessageForTags(messageList: any) {
  
    for (let i = 0; i < messageList.length; i++) {
      let message = messageList[i]["message"];
      let taggedUsers = messageList[i]["taggedUsers"];
      let taggedPatients = messageList[i]["taggedPatients"];
      
      if (message) {
        messageList[i]["message"] = message.replace(/<a.?href="\/(user|patient)\/([a-zA-Z\d]{24})".*?>\[\[([a-zA-Z\d]{24})\]\]<\/a>/g, ($m, p0, p1, p2) => {
          p2 = p2.trim();
          
          if (p0 == "user") {
            let user = taggedUsers.find((x) => x.userId == p2);
            if (user && user.fullName) {
              return `<span class='_label'>@${user.fullName} </span>`;
            }
          }

          if (p0 == "patient") {
            let patient = taggedPatients.find((x) => x.patientId == p2);
            if (patient && patient.patientId.trim() == p2) {
              return `<a href="${patient["redirectUrl"]}" target="_blank"><span class="_label2"> #patient: ${patient.patientIdentifier} </span> </a>`;
            }
          }
          return $m;
        });
      }
    }
    return messageList;
  
}
chatDirect(data){
  this.streamService.setChatConfigObs({
    chatType: "circle",
    circleData: { circleId: data.circleId, ownerId: data.ownerId,circleName:data.name },
    circleGroupData: { circleGroupId: data.allMemberGroupId, isAllMemberGroup: true,from:"2" },
    studyData: { studyId: data.studyId, studyNumber: data.studyNumber }
  });

  this.router.navigate(['/main/circles/circle-profile/circle-members'],{ queryParams: { id: data.circleId, ownerId:data.ownerId, studyId:data.studyId}})
}

ShowHideRead() {
  let mentionedOrNot: any;
  this.mentionsNot.forEach((element) => {
    element["showRead"] = true;
    if (element["isMentionRead"] == mentionedOrNot) element["showRead"] = false;
    else mentionedOrNot = element["isMentionRead"];
  });
}

isWordPresent(word: string) {
  let lastResult = false
  let OLList = word.includes('<ol')
  let ULList = word.includes('<ul')
  if(OLList || ULList) lastResult =  true
  
  return lastResult; 
  
}

}
